import { action, observable } from 'mobx';
import { getAxiosInstanceWithToken } from '../services/axios';
import { ChannelPartnerServiceProxy, CustomerInfosServiceProxy, CustomServiceProxy, GetAllBasicDataOutPutDto, GetAllThreeBasicMotorSriesOutPutDto, GetParamsATreeOutPutDto, GetSalesListOutput, QuotationPrincipleRow } from '../services/serviceProxy';
import { GetCusNoAndCusAdrNameListOutput } from '../services/serviceProxy';

declare var abp: any;
class CustomerInfoStore {
    customerInfosServiceProxy = new CustomerInfosServiceProxy();
    cus = new CustomServiceProxy();

    @observable cusNoAndCusAdrNameList: GetCusNoAndCusAdrNameListOutput[] = [];

    //电压基础信息
    @observable voltageList: string[] = [];
    //频率基础信息
    @observable frequencyList: string[] = [];
    //功率基础信息
    @observable powerList: string[] = [];
    //安装方式基础信息
    @observable basicMotorMountingList: string[] = [];
    //极数基础信息
    @observable poleNoList: string[] = [];
    //主机基础信息
    @observable basicMotorSriesList: GetParamsATreeOutPutDto[] = [];
    //能效基础信息
    @observable eneEffList: string[] = [];
    //编码基础信息
    @observable encoderList: string[] = [];
    //制动器基础信息
    @observable brakeList: string[] = [];
    //报价原则详情列表
    @observable quotationPrincipleRowList: QuotationPrincipleRow[] = [];
    /** 首开并发 onBlur 共用同一请求，避免重复拉取且互相覆盖 */
    private quotationPrincipleRowListPromise: Promise<QuotationPrincipleRow[]> | null = null;
    //机座号基础信息
    @observable frameNoList: number[] = [];
    //第三层级别系列基础信息
    @observable threeBasicMotorSriesList: GetAllThreeBasicMotorSriesOutPutDto[] = [];

    //全部的基础参数
    @observable basicData: GetAllBasicDataOutPutDto[] = null;

    //CP:责任销售的列表
    //其他角色:所有销售列表
    @observable saleList: GetSalesListOutput[] = [];

    private ensureQuotationPrincipleRowList = async () => {
        if (this.quotationPrincipleRowList.length > 0) {
            return this.quotationPrincipleRowList;
        }
        if (!this.quotationPrincipleRowListPromise) {
            this.quotationPrincipleRowListPromise = this.cus.getQuotationPrincipleRow()
                .then((list) => {
                    this.quotationPrincipleRowList = list || [];
                    return this.quotationPrincipleRowList;
                })
                .catch((err) => {
                    this.quotationPrincipleRowListPromise = null;
                    throw err;
                });
        }
        return this.quotationPrincipleRowListPromise;
    };

    @action
    async getCusNoAndCusAdrNameList(cusAdrName: string = '') {
        let result = await this.customerInfosServiceProxy.getCusNoAndCusAdrNameList()
        this.cusNoAndCusAdrNameList = result;
    }

    //使用自定义token
    useMyToken = (token: string) => {
        const instance = getAxiosInstanceWithToken(token);
        this.customerInfosServiceProxy = new CustomerInfosServiceProxy(null, instance);
        this.cus = new CustomServiceProxy(null, instance);
    }

    //整合获取全部的基础参数
    @action
    getAllBasicData = async () => {
        if (this.basicData === null) {
            var result = await this.cus.getAllBasicData();
            this.basicData = result;
            return result;
        } else {
            return this.basicData;
        }
    }

    //获取机座号基础信息
    @action
    getFrameNoList = async () => {
        if (this.frameNoList.length == 0) {
            var frameNoList = await this.cus.getAllFrameNo();
            this.frameNoList = frameNoList;
            return frameNoList;
        } else {
            return this.frameNoList;
        }
    }

    //获取第三级别系列基础信息
    @action
    getthreeBasicMotorSriesList = async (isFilterJIN?: boolean) => {
        if (this.threeBasicMotorSriesList.length == 0 || isFilterJIN !== undefined) {
            var threeBasicMotorSriesList = await this.cus.getAllThreeBasicMotorSries(isFilterJIN);
            this.threeBasicMotorSriesList = threeBasicMotorSriesList;
            return threeBasicMotorSriesList;
        } else {
            return this.threeBasicMotorSriesList;
        }
    }

    //获取电压基础信息
    @action
    getvoltageList = async () => {
        if (this.voltageList.length == 0) {
            var voltageList = await this.cus.getAllVoltage();
            this.voltageList = voltageList;
            return voltageList;
        } else {
            return this.voltageList;
        }
    }

    //获取频率基础信息
    @action
    getfrequencyList = async () => {
        if (this.frequencyList.length == 0) {
            var frequencyList = await this.cus.getAllFrequency();
            this.frequencyList = frequencyList;
            return frequencyList;
        } else {
            return this.frequencyList;
        }
    }

    //获取功率基础信息
    @action
    getpowerList = async () => {
        if (this.powerList.length == 0) {
            var powerList = await this.cus.getAllPower();
            this.powerList = powerList;
            return powerList;
        } else {
            return this.powerList;
        }
    }

    //获取安装方式基础信息
    @action
    getbasicMotorMountingList = async () => {
        if (this.basicMotorMountingList.length == 0) {
            var basicMotorMountingList = await this.cus.getAllBasicMotorMounting();
            this.basicMotorMountingList = basicMotorMountingList;
            return basicMotorMountingList;
        } else {
            return this.basicMotorMountingList;
        }
    }

    //获取极数基础信息
    @action
    getpoleNoList = async () => {
        if (this.poleNoList.length == 0) {
            var poleNoList = await this.cus.getAllPoleNo();
            this.poleNoList = poleNoList;
            return poleNoList;
        } else {
            return this.poleNoList;
        }
    }

    //获取主机基础信息
    @action
    getbasicMotorSriesList = async () => {
        if (this.basicMotorSriesList.length == 0) {
            var basicMotorSriesList = await this.cus.getAllBasicMotorSries();
            this.basicMotorSriesList = basicMotorSriesList;
            return basicMotorSriesList;
        } else {
            return this.basicMotorSriesList;
        }
    }

    //获取能效基础信息
    @action
    geteneEffList = async () => {
        if (this.eneEffList.length == 0) {
            var eneEffList = await this.cus.getAllEneEff();
            this.eneEffList = eneEffList;
            return eneEffList;
        } else {
            return this.eneEffList;
        }
    }

    //获取编码基础信息
    @action
    getencoderList = async () => {
        if (this.encoderList.length == 0) {
            var encoderList = await this.cus.getAllEncoder();
            this.encoderList = encoderList;
            return encoderList;
        } else {
            return this.encoderList;
        }
    }

    //获取制动器基础信息
    @action
    getbrakeList = async () => {
        if (this.brakeList.length == 0) {
            var brakeList = await this.cus.getAllBrake();
            this.brakeList = brakeList;
            return brakeList;
        } else {
            return this.brakeList;
        }
    }

    //获取销售列表
    @action
    getSaleList = async () => {
        if (this.saleList.length == 0) {
            const cpservice = new ChannelPartnerServiceProxy();
            var saleList = await cpservice.getSalesList();
            this.saleList = saleList;
            return saleList;
        } else {
            return this.saleList;
        }
    }

    //获取报价原则详情
    @action
    getQuotationPrincipleRow = async (code: string) => {
        await this.ensureQuotationPrincipleRowList();
        const row = this.quotationPrincipleRowList.find(x => x.code == code);
        if (row === null || row === undefined) {
            return "";
        } else {
            return row.quotationPrincipleDetails;
        }
    }

    //获取报价原则详情列表
    @action
    getQuotationPrincipleRowList = async () => {
        return this.ensureQuotationPrincipleRowList();
    }
}

export default CustomerInfoStore;
